module.exports = __webpack_public_path__ + "img/jonahs-art.dc7b3a9e.jpg";